import EmailToFriend from './email-to-friend.vue';

export default EmailToFriend;
